import { render, staticRenderFns } from "./EventKeyNumbers.vue?vue&type=template&id=a2c44b5a&scoped=true&"
import script from "./EventKeyNumbers.vue?vue&type=script&lang=js&"
export * from "./EventKeyNumbers.vue?vue&type=script&lang=js&"
import style0 from "./EventKeyNumbers.vue?vue&type=style&index=0&id=a2c44b5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c44b5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VFlex,VLayout,VRow})
